import type { LocaleMessages } from '../types';

export const es: LocaleMessages = {
  app: {
    brand: 'ACEX · Bolsa de capital de agentes',
    title: 'Pulse Terminal',
  },
  locale: {
    label: 'Idioma',
  },
  header: {
    chain: 'Cadena',
    refresh: 'actualización {ms}ms',
    chainFilterUniOnly: 'El filtro de cadena solo aplica en LIVE',
  },
  contour: {
    live: 'LIVE',
    uni: 'UNI',
    liveBadge: 'LIVE · {mode}',
    uniBadge: 'UNI · {phase}',
  },
  dataSource: {
    live: {
      label: 'LIVE · Factory / Hub',
      formula:
        'Capacidades del producto (catálogo hub) → promedios ACEX v0.2 por listing; filtro de cadena en capabilities',
    },
    uni: {
      label: 'UNI · Alien Monitor',
      formula:
        'Métricas del grafo → proxy $/call → ACEX v0.2 (NAV = $/call × success × trust × 100; index = $/call × success × 1000)',
    },
  },
  dataSourceBar: {
    loading: 'cargando…',
  },
  error: {
    uniHint: 'inicia Alien Monitor (/monitor/, modo UNI)',
    liveHint: 'necesitas API en /api/v2/capital/pricing (factory :9081)',
  },
  panel: {
    agentListings: 'Listings de agentes',
    agentListingsSub: 'CapShares · NAV en vivo',
    universeListings: 'Nodos del universo',
    universeListingsSub: 'Contorno UNI · grafo Alien Monitor',
    agentListing: 'Listing del agente',
    selectRow: 'elige una fila',
    selectHint:
      'Elige un listing para ver CapShare NAV, componentes del índice y series CapSense.',
    listingFallback: 'Listing',
  },
  listings: {
    emptyLive: 'Sin listings — inicia el pipeline de la factory o hub con capabilities',
    emptyUni: 'Sin nodos del universo — inicia Alien Monitor (modo UNI)',
    caps: '{count} caps',
    capabilities: '{count} capabilities',
    capShareNav: 'CapShare NAV',
    trust: 'trust {pct}%',
    idx: 'idx {value}',
    details: 'Detalles →',
    colListing: 'Listing',
    colCapShare: 'CapShare',
    colIndex: 'Índice',
    colIv: 'IV',
    colTrust: 'Trust',
    colAudit: 'Auditoría',
    colRoute: 'Ruta',
    colTrend: 'Tendencia',
    iv: 'IV {pct}%',
    uncovered: 'sin cobertura',
    watch: 'watch',
  },
  detail: {
    uniSubtitle: 'UNI · NAV del grafo del monitor (ACEX v0.2)',
    liveSubtitle: 'LIVE · CapShare desde capabilities del producto',
    capShareNav: 'CapShare NAV',
    indexLevel: 'Nivel del índice',
    iv: 'IV',
    pricePerCall: '$/call',
    success30d: 'Success 30d',
    trustScore: 'Trust score',
    reliability: 'Fiabilidad',
    indexComponents: 'Componentes del índice',
    change24h: '24h {value}',
    capsenseTitle: 'CapSense Options',
    capsenseSub: 'Fase 2 · Solana',
    openSeries: 'Series abiertas',
    capsenseHint: 'Calls sobre revenue index · vencimientos {days}d',
    liquidityTitle: 'Liquidity mesh',
    liquiditySub: 'enrutamiento',
    poaTitle: 'Proof-of-Audit',
    poaSub: 'cobertura de auditores en stake · fee share de invoke',
    insured: 'Asegurado',
    noCover: 'Sin cobertura',
    aggregateScore: 'Score agregado',
    totalCover: 'Cobertura total',
    auditors: 'Auditores',
    auditFee: 'Audit fee',
    accruedRewards: 'Rewards acumulados',
    noteSpread: 'Note spread',
    baseline: 'Baseline {value}',
    twap: 'TWAP {value}',
    drawdown: 'caída {pct}%',
    coverLine: 'cover {value}',
    scoreLine: 'score {pct}%',
    pendingLine: 'pending {value}',
  },
  defaultRisk: {
    none: 'Riesgo de default: bajo',
    watch: 'Riesgo de default: watch',
    elevated: 'Riesgo de default: elevated',
    defaulted: 'Riesgo de default: defaulted',
  },
  statusBar: {
    acex: 'ACEX {version}',
    listings: '{count} listings',
    latency: '{ms}ms',
    navSum: 'Σ NAV {value}',
    version: 'Pulse v0.1',
  },
  mobile: {
    close: 'Cerrar',
  },
  ticker: {
    uni: 'uni',
  },
};
